(() => {
  "use strict";
  if (customElements.get("gno-countdown")) return;

  class GnoCountdown extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const duration = Number(this.dataset.duration);
      if (!Number.isFinite(duration) || duration <= 0) return;
      this.clock = this.querySelector('[role="timer"]');
      this.expired = this.querySelector(".gno-countdown__expired");
      this.values = ["hours", "minutes", "seconds"].map((unit) =>
        this.querySelector(`[data-gno-${unit}]`),
      );
      if (!this.clock || !this.expired || this.values.some((node) => !node))
        return;
      this.controller = new AbortController();
      this.endAt ??= Date.now() + duration * 1000;
      document.addEventListener("visibilitychange", () => this.tick(), {
        signal: this.controller.signal,
      });
      this.tick();
    }

    tick() {
      clearTimeout(this.timeout);
      const now = Date.now();
      const repeat = Number(this.dataset.repeat) * 1000;
      if (now >= this.endAt && Number.isFinite(repeat) && repeat > 0) {
        this.endAt += (Math.floor((now - this.endAt) / repeat) + 1) * repeat;
      }
      const remaining = Math.max(0, Math.ceil((this.endAt - now) / 1000));
      const values = [
        Math.floor(remaining / 3600),
        Math.floor((remaining % 3600) / 60),
        remaining % 60,
      ];
      this.values.forEach((node, index) => {
        node.textContent = String(values[index]).padStart(2, "0");
      });
      this.clock.hidden = remaining === 0;
      this.expired.hidden = remaining > 0;
      if (remaining > 0 && !document.hidden) {
        this.timeout = setTimeout(() => this.tick(), 1000 - (now % 1000));
      }
    }

    disconnectedCallback() {
      clearTimeout(this.timeout);
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define("gno-countdown", GnoCountdown);
})();
